import styles from './Loader.module.scss';
import classNames from 'classnames';

const Loader = ({ small }) => {
    return (
        <div className={classNames(styles['Loader'], { [styles['Loader--Small']]: small })}>
            <i />
        </div>
    );
};

Loader.propTypes = {};
export default Loader;
